export default __webpack_public_path__ + "media/images/front/user_page_announcement/point_sp-cb2676c3b8c4612ab3e2878c3f1accc0.png";